import {
  ContentMethodRichText,
  ContentMethodSubmit
} from "../../manage/methods"

export default {
  FILE: {
    key: "SubmissionFile",
    fieldsData: {
      filetype: {
        placeholder: "Select file type",
        optional: true
      },
      richtext: {
        placeholder: "Write instructions for the learner..."
      }
    },
    renderForm({ fieldsData }) {
      return (
        <ContentMethodSubmit
          filetypeProps={fieldsData.filetype}
          richtextProps={fieldsData.richtext}
        />
      )
    },
    getValues(content) {
      const values = {
        filetype:
          (content != null ? content.submission_file_type : undefined) || "",
        richtext: content != null ? content.submission_instructions : undefined
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = {
        submission_file_type: fieldsData.filetype.value.value || "",
        submission_instructions: fieldsData.richtext.value
      }
      return saveData
    }
  },

  ELSEWHERE: {
    key: "SubmissionElsewhere",
    fieldsData: {
      richtext: {
        placeholder: "Submit elsewhere instructions..."
      }
    },
    renderForm({ fieldsData }) {
      return (
        <ContentMethodRichText {...Object.assign({}, fieldsData.richtext)} />
      )
    },
    getValues(content) {
      const values = {
        richtext:
          content != null ? content.submit_elsewhere_instructions : undefined
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = {
        submit_elsewhere_instructions: fieldsData.richtext.value
      }
      return saveData
    }
  },

  TEXT: {
    key: "SubmissionText",
    fieldsData: {
      richtext: {
        placeholder: "Submit text instructions..."
      }
    },
    getValues(content) {
      const values = {
        richtext: content != null ? content.submission_instructions : undefined
      }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = { submission_instructions: fieldsData.richtext.value }
      return saveData
    },
    renderForm({ fieldsData }) {
      return (
        <ContentMethodRichText {...Object.assign({}, fieldsData.richtext)} />
      )
    }
  }
}
